/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.63   Rana simulation core release: 3.7.3   deployed on:  08:32AM (UTC) on September 25, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { UsePreconditionerCgEnum } from "./UsePreconditionerCgEnum";
import {
  UsePreconditionerCgEnumFromJSON,
  UsePreconditionerCgEnumFromJSONTyped,
  UsePreconditionerCgEnumToJSON,
  UsePreconditionerCgEnumToJSONTyped,
} from "./UsePreconditionerCgEnum";
import type { UseAdvection1dEnum } from "./UseAdvection1dEnum";
import {
  UseAdvection1dEnumFromJSON,
  UseAdvection1dEnumFromJSONTyped,
  UseAdvection1dEnumToJSON,
  UseAdvection1dEnumToJSONTyped,
} from "./UseAdvection1dEnum";

/**
 *
 * @export
 * @interface PatchedPhysicalSettings
 */
export interface PatchedPhysicalSettings {
  /**
   *
   */
  readonly id?: number;
  /**
   *
   */
  readonly simulationId?: number;
  /**
   * Options:
   * 0 = off
   * 1 = momentum conservative
   * 2 = energy conservative
   * 3 = combined momentum and energy conservative
   *
   *
   * * `0` - off
   * * `1` - momentum conservative
   * * `2` - energy conservative
   * * `3` - combined momentum and energy conservative
   */
  useAdvection1d?: UseAdvection1dEnum;
  /**
   * Options:
   * 0 = off
   * 1 = standard
   *
   *
   * * `0` - off
   * * `1` - standard
   */
  useAdvection2d?: UsePreconditionerCgEnum;
}

/**
 * Check if a given object implements the PatchedPhysicalSettings interface.
 */
export function instanceOfPatchedPhysicalSettings(value: object): value is PatchedPhysicalSettings {
  return true;
}

export function PatchedPhysicalSettingsFromJSON(json: any): PatchedPhysicalSettings {
  return PatchedPhysicalSettingsFromJSONTyped(json, false);
}

export function PatchedPhysicalSettingsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PatchedPhysicalSettings {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"] == null ? undefined : json["id"],
    simulationId: json["simulation_id"] == null ? undefined : json["simulation_id"],
    useAdvection1d:
      json["use_advection_1d"] == null
        ? undefined
        : UseAdvection1dEnumFromJSON(json["use_advection_1d"]),
    useAdvection2d:
      json["use_advection_2d"] == null
        ? undefined
        : UsePreconditionerCgEnumFromJSON(json["use_advection_2d"]),
  };
}

export function PatchedPhysicalSettingsToJSON(json: any): PatchedPhysicalSettings {
  return PatchedPhysicalSettingsToJSONTyped(json, false);
}

export function PatchedPhysicalSettingsToJSONTyped(
  value?: Omit<PatchedPhysicalSettings, "id" | "simulationId"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    use_advection_1d: UseAdvection1dEnumToJSON(value["useAdvection1d"]),
    use_advection_2d: UsePreconditionerCgEnumToJSON(value["useAdvection2d"]),
  };
}
